export default __webpack_public_path__ + "static/media/pdf.711972df.png";